import { useCallback, useMemo } from 'react';
import { toast } from 'sonner';
import api, { formatApiError } from '../../lib/api';

export function useWalletActions({ refresh }) {
  const requestTopUp = useCallback(async ({ amount, method, reference, proof }) => {
    try {
      await api.post('/wallet/topup', { amount: Number(amount), method, reference, proof: proof || '' });
      toast.success('Top-up request submitted', { description: 'KELATE will verify your transfer and credit your wallet.' });
      await refresh(false);
    } catch (e) { toast.error(formatApiError(e)); }
  }, [refresh]);

  const topUpAction = useCallback(async (requestId, action) => {
    try {
      await api.post(`/admin/wallet/requests/${requestId}/action`, { action });
      toast.success(action === 'approve' ? 'Top-up approved — wallet credited' : 'Top-up rejected');
      await refresh(false);
    } catch (e) { toast.error(formatApiError(e)); }
  }, [refresh]);

  const adminWalletAdjust = useCallback(async ({ ownerType, ownerKey, amount, note }) => {
    try {
      await api.post('/admin/wallet/adjust', { ownerType, ownerKey, amount: Number(amount), note });
      toast.success('Wallet adjusted');
      await refresh(false);
    } catch (e) { toast.error(formatApiError(e)); }
  }, [refresh]);

  const promoteProduct = useCallback(async (merchantId, productId, productName) => {
    try {
      await api.post(`/merchant/products/${productId}/promote`);
      toast.success('Product promoted', { description: 'RM20 spent from your ads wallet. Product is now Featured across KELATE.' });
      await refresh(true);
    } catch (e) {
      const msg = formatApiError(e);
      toast.error(msg.toLowerCase().includes('insufficient') ? 'Insufficient ads wallet balance' : msg,
        msg.toLowerCase().includes('insufficient') ? { description: 'Top up your ads wallet to promote products (RM20 per boost).' } : undefined);
    }
  }, [refresh]);

  return useMemo(() => ({ requestTopUp, topUpAction, adminWalletAdjust, promoteProduct }),
    [requestTopUp, topUpAction, adminWalletAdjust, promoteProduct]);
}
